import React, { FC, useState, useRef, useEffect, ChangeEvent } from 'react';

import { StringField } from 'models/value-objects/editor-field';
import { Model } from './index.model';

import { ShowIcon, HideIcon } from 'views/components/icons';
import { Root } from '../input-base/index.styled';

interface Props {
  field: StringField;
  onEdit: (field: StringField) => void;
  alt?: string;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  focused?: boolean;
  secure?: boolean;
  prefix?: string;
  suffix?: string;
}

const StringInput: FC<Props> = props => {

  const { field, onEdit, placeholder = '', alt, readOnly = false, disabled = false, focused = false, secure = false, prefix, suffix } = props;
  const input = useRef<HTMLInputElement>(null);
  const [model, setModel] = useState(new Model({ field, alt, secure }));

  function onChange(e: ChangeEvent<HTMLInputElement>) {
    const it = model.change(e.target.value);
    onEdit(it.field);
    setModel(it);
  }

  function onFocus() {
    if (model.isAlt) input.current?.select();
  }

  function toggle() {
    setModel(model.toggle());
  }

  function watchField() {
    if (field.value === model.field.value) return;
    setModel(model.renew(field));
  }

  function watchFocused() {
    if (focused) input.current?.focus();
  }

  useEffect(watchField, [field]);
  useEffect(watchFocused, [focused]);

  return (
    <Root>
      <input
        ref={input}
        type={model.hiding ? 'password' : 'text'}
        value={model.value}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={model.alt || placeholder}
        readOnly={readOnly}
        disabled={disabled}
        className={model.isAlt ? 'alt' : ''}
      />
      {!!prefix && <span className="prefix">{prefix}</span>}
      {!!suffix && <span className="suffix">{suffix}</span>}
      {secure && <button tabIndex={-1} onClick={() => toggle()}>{model.hiding ? <ShowIcon /> : <HideIcon />}</button>}
      {model.field.error && <p>{model.field.error}</p>}
    </Root>
  );

};

export { StringInput };